import React from 'react'
import Manager from '../../public/components/Manager'
import JudgeStandardApplyTypeSelectDiv from './JudgeStandardApplyTypeSelectDiv'
import JudgeStandardApplyDetail from './JudgeStandardApplyDetail'
Ext.require('Ext.Toast')

const config = {
	tabs: {
		申请中: {
			buttons: [
				{
					text: '申请...', handler: ({ showDetail, refreshPage }) =>
						Tyan.pubForm.showDialog('申请类型选择', props => <JudgeStandardApplyTypeSelectDiv {...props} showDetail={showDetail} onSave={refreshPage} />)
				},
			],
			columns: [
				{ _text: '申请编号', field: 'Number', minWidth: 150, search: true, },
				{ _text: '申请类型', field: 'ApplyType', minWidth: 150, flex: 1, filter: true },
				{ _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left' },
				{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
				{ _text: '判定标准', field: 'JudgeStandard', minWidth: 250, flex: 2, search: true, },
			],
			onDoubleTap: ({ showDetail, refreshPage }, data) => {
				showDetail(props => <JudgeStandardApplyDetail {...props} id={data.id} />)
			}
		},
		退回申请: {
			buttons: [
			],
			columns: [
				{ _text: '申请编号', field: 'Number', minWidth: 150, search: true, },
				{ _text: '申请类型', field: 'ApplyType', minWidth: 150, flex: 1, filter: true },
				{ _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left' },
				{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
				{ _text: '判定标准', field: 'JudgeStandard', minWidth: 250, flex: 2, search: true, },
				{ _text: '退回原因', field: 'RecentOperationMemo', minWidth: 250 },
			],
			onDoubleTap: ({ showDetail, refreshPage }, data) => {
				showDetail(props => <JudgeStandardApplyDetail {...props} id={data.id} />)
			}
		},
		已完成: {
			buttons: [
			],
			columns: [
				{ _text: '申请编号', field: 'Number', minWidth: 150, search: true, },
				{ _text: '申请类型', field: 'ApplyType', minWidth: 150, flex: 1, filter: true },
				{ _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left' },
				{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
				{ _text: '判定标准', field: 'JudgeStandard', minWidth: 250, flex: 2, search: true, },
			],
			onDoubleTap: ({ showDetail, refreshPage }, data) => {
				showDetail(props => <JudgeStandardApplyDetail {...props} id={data.id} />)
			}
		},
		已中止: {
			buttons: [
			],
			columns: [
				{ _text: '申请编号', field: 'Number', minWidth: 150, search: true, },
				{ _text: '申请类型', field: 'ApplyType', minWidth: 150, flex: 1, filter: true },
				{ _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left' },
				{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
				{ _text: '判定标准', field: 'JudgeStandard', minWidth: 250, flex: 2, search: true, },
			],
		},
	}

}

export default props => <Manager {...props} config={config} />